import "./SendMessage.css"


export const SendMessage=()=>{
 

  return (

      <div id="msg-contu">

      <div id="sent-msg-logo-div">
        <img id="sent-msg-logo"   src="https://i.ibb.co/5j1VHww/Untitled.png" alt="" />
      </div>

         <div id="text-div-chat">
       
         <h3 id="head">Your Messages</h3>
         <p id="para">Send private photos and messages to a friend or group.</p>
       
       </div>

       <div id="button-div">
       <button id="button-chat">Send Message</button>
       
       </div>

      </div>

    
  )


}